module.exports = __webpack_public_path__ + "img/day18.785c9eb4.svg";